import React from 'react';
import PassengerForm from "./PassengerForm";

export type Passenger = {
  id?: string;
  fullName?: string;
  phone?: String;
  email?: string;
  dob?: Date;
  idType?: string;
  idNumber?: string;
  nationality?: string;
  errors: {
    [K in keyof Omit<Passenger, 'id' | 'errors'>]?: boolean
  },
}


const PassengersDetails = ({ passengers, onChange, onBlur }: {
  passengers: Passenger[],
  onChange: (inder: number, key: string, value: string) => void,
  onBlur: (index: number, key: string, validator: (value: string) => string) => void; }
) => {

  return (
    <div className="passenger-details__container">
      {passengers.map((passenger, index) => (
        <PassengerForm
          key={index}
          index={index}
          data={passenger}
          onChange={onChange}
          onBlur={onBlur}
        />
      ))}
    </div>
  );
};

export default PassengersDetails;
